import React, { useState, useEffect, useRef } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState, agreePrivacyPolicyState, agreeMarkekingState } from "../../stores/atoms";
import { auth } from "../../actions/firebase";
import { awsInstance } from "../../actions/api";
import { S3, S3_BUCKET, S3_PATH, getTimeStamp, inputValidation } from "../../actions/utiles";
import Loading from "./../Loading";

function Register({ isLogined, history }) {
  const [, setUser] = useRecoilState(userState);
  const isAgreePrivacyPolicy = useRecoilValue(agreePrivacyPolicyState);
  const isAgreeMarketing = useRecoilValue(agreeMarkekingState);
  const [businessNumber1, setBusinessNumber1] = useState("");
  const [businessNumber2, setBusinessNumber2] = useState("");
  const [businessNumber3, setBusinessNumber3] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordCheck, setPasswordCheck] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [paymentCard, setPaymentCard] = useState("");
  const [paymentTaxBill, setPaymentTaxBill] = useState("");
  const [isUse, setIsUse] = useState("");
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [filePath, setFilePath] = useState(null);

  // 유효성 체크
  const [isBusinessNumber1Valid, setIsBusinessNumber1Valid] = useState(true);
  const [isBusinessNumber2Valid, setIsBusinessNumber2Valid] = useState(true);
  const [isBusinessNumber3Valid, setIsBusinessNumber3Valid] = useState(true);
  const [isCompanyNameValid, setIsCompanyNameValid] = useState(true);
  const [isCompanyFileValid, setIsCompanyFileValid] = useState(true);
  const [isNameValid, setIsNameValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isEmailInputValid, setIsEmailInputValid] = useState(true);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [isPasswordCheckValid, setIsPasswordCheckValid] = useState(true);
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isPhoneNumberInputValid, setIsphoneNumberInputValid] = useState(true);
  const [isPaymentValid, setIsPaymentValid] = useState(true);
  const [isSystemUseValid, setIsSystemUseValid] = useState(true);

  const businessNumber1Ref = useRef();
  const businessNumber2Ref = useRef();
  const businessNumber3Ref = useRef();
  const companyNameRef = useRef();
  const fileInputRef = useRef();
  const companyFileRef = useRef();
  const fileButtonRef = useRef();
  const nameRef = useRef();
  const phoneNumberRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordCheckRef = useRef();

  if (isLogined) {
    setUser(null);
    sessionStorage.removeItem("user");
  }

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  useEffect(() => {
    if (password && password.length >= 8) {
      setIsPasswordValid(true);
    }
    if (password === passwordCheck) {
      setIsPasswordCheckValid(true);
    }
    if (paymentCard || paymentTaxBill) {
      setIsPaymentValid(true);
    }
    if (isUse) {
      setIsSystemUseValid(true);
    }
    if (file) {
      setIsCompanyFileValid(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password, passwordCheck, paymentCard, paymentTaxBill, isUse, file]);

  const handleFileButtonClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click();
  }

  const onUploadFileChange = (event) => {
    const file = event.target.files[0];
    const fileName = file.name;
    const lastDot = fileName.lastIndexOf('.') + 1;
    const fileExt = fileName.substring(lastDot, fileName.length).toLowerCase();
    if(['pdf'].indexOf(fileExt) === -1) {
      alert('PDF 파일만 업로드 가능합니다.');
      fileInputRef.current.value = null;
      return false;
    }
    setFile(event.target.files[0]);
    setFilePath(S3_PATH + getTimeStamp() + '/license.pdf');
    if (file) {
      setIsCompanyFileValid(true);
    } else {
      setIsCompanyFileValid(false);
    }
  }

  const onFormSubmit = async (event) => {
    event.preventDefault();

    if (
      !businessNumber1 ||
      businessNumber1.length < 3 ||
      !isBusinessNumber1Valid
    ) {
      businessNumber1Ref.current.focus();
      setIsBusinessNumber1Valid(false);
      return false;
    }
    if (
      !businessNumber2 ||
      businessNumber2.length < 2 ||
      !isBusinessNumber2Valid
    ) {
      businessNumber2Ref.current.focus();
      setIsBusinessNumber2Valid(false);
      return false;
    }
    if (
      !businessNumber3 ||
      businessNumber3.length < 5 ||
      !isBusinessNumber3Valid
    ) {
      businessNumber3Ref.current.focus();
      setIsBusinessNumber3Valid(false);
      return false;
    }
    if (!companyName || !isCompanyNameValid) {
      companyNameRef.current.focus();
      setIsCompanyNameValid(false);
      return false;
    }
    if (!name || !isNameValid) {
      nameRef.current.focus();
      setIsNameValid(false);
      return false;
    }
    if (!phoneNumber || !isPhoneNumberValid || phoneNumber < 11) {
      phoneNumberRef.current.focus();
      setIsPhoneNumberValid(false);
      return false;
    }
    if (!email || !isEmailValid) {
      emailRef.current.focus();
      setIsEmailInputValid(false);
      return false;
    }
    if (!password || password.length < 8 || !isPasswordValid) {
      passwordRef.current.focus();
      setIsPasswordValid(false);
      return false;
    }
    if (!passwordCheck || !isPasswordCheckValid) {
      passwordCheckRef.current.focus();
      setIsPasswordCheckValid(false);
      return false;
    }
    if (!paymentCard && !paymentTaxBill) {
      setIsPaymentValid(false);
      return false;
    }
    if (!isUse) {
      setIsSystemUseValid(false);
      return false;
    }
    if (!file || !isCompanyFileValid) {
      companyFileRef.current.focus();
      setIsCompanyFileValid(false);
      return false;
    }

    const params = {
      'Bucket': S3_BUCKET,
      'Key': filePath,
      'Body': file,
      'ACL': 'public-read',
      'ContentType': 'application/pdf'
    }
    S3.upload(params, async (err, result) => {
      try {
        setLoading(true);
        if (err) { 
          throw err;
        }
        await auth.createUserWithEmailAndPassword(email, password);
        
        const { data } = await awsInstance.post("business/company/sign-up", {
          corporate_registration_number: `${businessNumber1}${businessNumber2}${businessNumber3}`,
          name: companyName,
          license_file_path: filePath ? filePath : '',
          license_file_name: file ? file.name : '',
          admin_name: name,
          admin_phone_number: phoneNumber,
          admin_email: email,
          use_card: paymentCard ? "1" : "0",
          use_tax_bill: paymentTaxBill ? "1" : "0",
          use_system: isUse === "1" ? "1" : "0",
          agree_privacy_policy: isAgreePrivacyPolicy ? "1" : "0",
          agree_marketing: isAgreeMarketing ? "1" : "0",
        });
        if (data.code === "SUCCESS") {
          history.push("/register-success");
        } else {
          alert(data.message);
        }
      } catch (e) {
        if (e.code === "auth/email-already-in-use") {
          alert("이미 사용중인 이메일입니다.");
        } else {
          await auth.currentUser.delete();
          console.log(e)
          alert("회원가입에 실패하였습니다.");
        }
      } finally {
        setLoading(false);
      }
    });
  };

  const onCompanyNumberChange = (e) => {
    const number = e.target.value;
    const numberName = e.target.name;
    const companyNumberRegExp = /^[0-9]+$/; // only number
    if (numberName === "businessNumber1") {
      setBusinessNumber1(number);
      if (
        number.match(companyNumberRegExp) &&
        number.length === 3 &&
        number.search(/\s/) === -1 // 공백체크
      ) {
        setIsBusinessNumber1Valid(true);
        businessNumber2Ref.current.focus();
      } else {
        setIsBusinessNumber1Valid(false);
      }
    } else if (numberName === "businessNumber2") {
      setBusinessNumber2(number);
      if (
        number.match(companyNumberRegExp) &&
        number.length === 2 &&
        number.search(/\s/) === -1 // 공백체크
      ) {
        setIsBusinessNumber2Valid(true);
        businessNumber3Ref.current.focus();
      } else {
        setIsBusinessNumber2Valid(false);
      }
    } else {
      setBusinessNumber3(number);
      if (
        number.match(companyNumberRegExp) &&
        number.length === 5 &&
        number.search(/\s/) === -1 // 공백체크
      ) {
        setIsBusinessNumber3Valid(true);
      } else {
        setIsBusinessNumber3Valid(false);
      }
    }
  };

  const onCompanyNameChange = (e) => {
    const companyName = e.target.value;
    setCompanyName(companyName);

    if (companyName.trim().length >= 1) {
      setIsCompanyNameValid(true);
    } else {
      setIsCompanyNameValid(false);
    }
  };

  const onNameChange = (e) => {
    const name = e.target.value;
    setName(name);
    const checkKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // korean
    const checkEng = /[a-zA-Z]/; // english
    if ((name.match(checkKor) || name.match(checkEng)) && name.length >= 2) {
      setIsNameValid(true);
    } else {
      setIsNameValid(false);
    }
  };

  const onPhoneNumberChange = (e) => {
    const phoneNumber = e.target.value;
    setPhoneNumber(phoneNumber);
    const phoneNumberRegExp = /^[0-9]+$/;
    if (phoneNumber.match(phoneNumberRegExp) && phoneNumber.length === 11) {
      setIsPhoneNumberValid(true);
      setIsphoneNumberInputValid(true);
    } else {
      setIsPhoneNumberValid(false);
    }
  };

  const onEmailChange = (event) => {
    const email = event.target.value;
    const emailRegExp = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;
    setEmail(email);
    if (email.match(emailRegExp)) {
      setIsEmailValid(true);
      setIsEmailInputValid(true);
    } else {
      setIsEmailValid(false);
    }
  };

  const onPasswordChange = (event) => {
    const password = event.target.value;
    setPassword(password);
    if (password >= 8) {
      setIsPasswordValid(true);
    } else {
      setIsPasswordValid(false);
    }
  };

  const onPasswordCheckChange = (event) => {
    const passwordCheck = event.target.value;
    setPasswordCheck(passwordCheck);
    if (password === passwordCheck) {
      setIsPasswordCheckValid(true);
    } else {
      setIsPasswordCheckValid(false);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      <div className="register">
        <h3>가입 정보입력</h3>
        <p className="txt-center font-small txt-gray">
          고요한 비즈니스의 원활한 이용을 위하여 모든 정보를 기입해주세요
        </p>
        <form
          className="register-form display-flex flex-column align-items-center"
          onSubmit={onFormSubmit}
        >
          <div>
            <h5 className="mb-3 mt-4">사업자정보</h5>
            <table className="table">
              <tbody>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="businessNumber">
                      사업자번호
                    </label>
                  </th>
                  <td colSpan="3">
                    <div className="display-flex justify-content-between align-items-center">
                      <input
                        ref={businessNumber1Ref}
                        className={`form-control width-30 ${inputValidation(
                          isBusinessNumber1Valid
                        )}`}
                        id="businessNumber"
                        name="businessNumber1"
                        type="text"
                        value={businessNumber1}
                        maxLength="3"
                        onChange={onCompanyNumberChange}
                      />
                      &nbsp;-&nbsp;
                      <input
                        ref={businessNumber2Ref}
                        className={`form-control width-20 ${inputValidation(
                          isBusinessNumber2Valid
                        )}`}
                        type="text"
                        name="businessNumber2"
                        value={businessNumber2}
                        maxLength="2"
                        onChange={onCompanyNumberChange}
                      />
                      &nbsp;-&nbsp;
                      <input
                        ref={businessNumber3Ref}
                        className={`form-control width-50 ${inputValidation(
                          isBusinessNumber3Valid
                        )}`}
                        type="text"
                        name="companyNumber3"
                        value={businessNumber3}
                        maxLength="5"
                        onChange={onCompanyNumberChange}
                      />
                    </div>
                    <div className="txt-left">
                      {(!isBusinessNumber1Valid ||
                        !isBusinessNumber2Valid ||
                        !isBusinessNumber3Valid) && (
                        <span
                          style={{
                            fontSize: "80%",
                            color: "#dc3545",
                            margin: "0 0 0.5rem 0",
                          }}
                        >
                          사업자 번호를 입력하세요.
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="companyName">
                      사업자명
                    </label>
                  </th>
                  <td colSpan="3">
                    <input
                      className={`form-control mb-1 ${inputValidation(
                        isCompanyNameValid
                      )}`}
                      id="companyName"
                      value={companyName}
                      maxLength="20"
                      onChange={onCompanyNameChange}
                      ref={companyNameRef}
                    />
                    {!isCompanyNameValid ? (
                      <p className="invalid-feedback">사업자명을 입력하세요.</p>
                    ) : (
                      <p className="font-small txt-gray txt-left mb-0">
                        사업자 등록증의 기업명을 입력하세요.
                      </p>
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="companyFile">
                      사업자등록증
                    </label>
                  </th>
                  <td colSpan="3">
                  <div className="display-flex justify-content-between align-items-center">
                    <input
                      type="file"
                      accept=".pdf"
                      className="form-control mb-1"
                      maxLength="20"
                      onChange={onUploadFileChange}
                      ref={fileInputRef}
                      hidden
                    />
                    <input
                      className={`form-control mb-1 width-80 ${inputValidation(
                        isCompanyFileValid
                      )}`}
                      defaultValue={file ? file.name : ''}
                      maxLength="20"
                      ref={companyFileRef}
                    />
                    <button className="btn-dark-sm font-bold" ref={fileButtonRef} onClick={handleFileButtonClick}>
                      첨부
                    </button>
                  </div>
                  <p className="font-small txt-gray txt-left mb-0">
                    파일을 첨부해주세요.(PDF파일만 가능합니다.)
                  </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <h5 className="mb-3 mt-5">기업 관리자정보</h5>
            <table className="table">
              <tbody>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="name">
                      이름
                    </label>
                  </th>
                  <td colSpan="3">
                    <input
                      ref={nameRef}
                      className={`form-control mb-1 ${inputValidation(
                        isNameValid
                      )}`}
                      id="name"
                      type="text"
                      value={name}
                      maxLength="10"
                      onChange={onNameChange}
                    />
                    <div className="txt-left">
                      {!isNameValid && (
                        <span
                          style={{
                            fontSize: "80%",
                            color: "#dc3545",
                            margin: "0 0 0.5rem 0",
                          }}
                        >
                          이름을 입력하세요.
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="phoneNumber">
                      휴대폰 번호
                    </label>
                  </th>
                  <td colSpan="3">
                    <input
                      ref={phoneNumberRef}
                      className={`form-control mb-1 ${inputValidation(
                        isPhoneNumberInputValid && isPhoneNumberValid
                      )}`}
                      id="phoneNumber"
                      type="text"
                      value={phoneNumber}
                      onChange={onPhoneNumberChange}
                      maxLength="11"
                    />
                    {!isPhoneNumberValid ? (
                      <p className="invalid-feedback">
                        11자리 숫자의 휴대폰 번호를 입력하세요.
                      </p>
                    ) : (
                      <p className="font-small txt-gray txt-left mb-0">
                        -없이 입력
                      </p>
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="email">
                      이메일
                    </label>
                  </th>
                  <td colSpan="3">
                    <input
                      ref={emailRef}
                      className={`form-control mb-1 ${inputValidation(
                        isEmailInputValid && isEmailValid
                      )}`}
                      id="email"
                      type="text"
                      value={email}
                      maxLength="30"
                      onChange={onEmailChange}
                    />
                    {!isEmailInputValid || !isEmailValid ? (
                      <p className="invalid-feedback">
                        회사도메인으로 이메일을 입력하세요.
                      </p>
                    ) : (
                      <p className="font-small txt-gray txt-left mb-0">
                        회사도메인으로 생성된 이메일로 가입해주세요.
                      </p>
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="password">
                      비밀번호
                    </label>
                  </th>
                  <td colSpan="3">
                    <input
                      ref={passwordRef}
                      id="password"
                      className={`form-control mb-1 ${inputValidation(
                        isPasswordValid
                      )}`}
                      type="password"
                      value={password}
                      maxLength="17"
                      autoComplete="new-password"
                      onChange={onPasswordChange}
                    />
                    {!isPasswordValid ? (
                      <p className="invalid-feedback">
                        8자리 이상 입력해주세요.
                      </p>
                    ) : (
                      <p className="font-small txt-left txt-gray mb-0">
                        8자리 이상 입력해주세요.
                      </p>
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="passwordCheck">
                      비밀번호 확인
                    </label>
                  </th>
                  <td colSpan="3">
                    <input
                      ref={passwordCheckRef}
                      id="passwordCheck"
                      className={`form-control mb-1 ${inputValidation(
                        isPasswordCheckValid
                      )}`}
                      type="password"
                      value={passwordCheck}
                      maxLength="17"
                      onChange={onPasswordCheckChange}
                    />
                    {!isPasswordCheckValid ? (
                      <p className="invalid-feedback">비밀번호와 다릅니다.</p>
                    ) : (
                      <p className="font-small txt-gray txt-left mb-0">
                        비밀번호 확인을 위해 한번 더 입력해주세요.
                      </p>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <h5 className="mb-3 mt-5">결제 정보</h5>
            <table className="table">
              <tbody>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="payment">
                      결제수단
                    </label>
                  </th>
                  <td colSpan="3">
                    <div className="txt-left display-flex">
                      <div className="width-50">
                        <input
                          className={`form-check-input ml-1 `}
                          id="card"
                          type="checkbox"
                          value={paymentCard}
                          checked={paymentCard}
                          onChange={(event) =>
                            setPaymentCard(event.target.checked)
                          }
                        />
                        <label className="form-check-label ml-4" htmlFor="card">
                          법인카드
                        </label>
                      </div>
                      <div className="width-50">
                        <input
                          className="form-check-input"
                          id="taxBill"
                          type="checkbox"
                          value={paymentTaxBill}
                          checked={paymentTaxBill}
                          onChange={(event) =>
                            setPaymentTaxBill(event.target.checked)
                          }
                        />
                        <label className="form-check-label" htmlFor="taxBill">
                          세금계산서발행
                        </label>
                      </div>
                    </div>
                    <div>
                      {!isPaymentValid && (
                        <p
                          style={{
                            textAlign: "left",
                            fontSize: "80%",
                            color: "#dc3545",
                            margin: "0 0 0.5rem 0",
                          }}
                        >
                          결제수단을 선택해주세요.
                        </p>
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className="background-light font-small">
                    <label className="mb-0" htmlFor="password">
                      연계고용제도
                      <br />
                      활용여부
                    </label>
                  </th>
                  <td colSpan="3">
                    <div className="txt-left display-flex">
                      <div className="width-50">
                        <input
                          className="form-check-input ml-1"
                          id="systemUSe"
                          name="system"
                          type="radio"
                          value={1}
                          onChange={(event) => setIsUse(event.target.value)}
                        />
                        <label
                          className="form-check-label ml-4"
                          htmlFor="systemUSe"
                        >
                          사용
                        </label>
                      </div>
                      <div className="width-50">
                        <input
                          className={`form-check-input`}
                          id="systemNotUse"
                          name="system"
                          type="radio"
                          value={0}
                          onChange={(event) => setIsUse(event.target.value)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="systemNotUse"
                        >
                          사용 안 함
                        </label>
                      </div>
                    </div>
                    <div>
                      {!isSystemUseValid && (
                        <p
                          style={{
                            textAlign: "left",
                            fontSize: "80%",
                            color: "#dc3545",
                            margin: "0 0 0.5rem 0",
                          }}
                        >
                          연계고용제도 활용여부를 선택해주세요.
                        </p>
                      )}
                    </div>
                    <div>
                      <p className="txt-gray font-small txt-left">
                        *연계고용제도를 이용하기 위해서는 별도의 추가 계약이
                        필요하며 세금계산서 발행 방식으로만 비용정산이
                        가능합니다.
                      </p>
                      <p className="txt-gray font-small txt-left">
                        *장애인고용부담금을 내고 있는 기업의 경우 이용금액의
                        최대 50%까지 장애인고용부담금이 감면됩니다.
                      </p>
                      <a href="https://www.goyohanbusiness.com/system" target="_blank" rel="noreferrer">
                    <p className="txt-left txt-gray font-small underline-gray">
                      자세히 알아보기
                    </p>
                  </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="button-area mt-4 txt-center">
            <button
              className="btn-white-md mr-4 font-bold"
              type="button"
              onClick={goBack}
            >
              이전
            </button>
            <button className="btn-blue-md font-bold" type="submit">
              가입 신청
            </button>
          </div>
        </form>
      </div>
      <Loading loading={loading} />
    </>
  );
}

export default Register;
